import { get } from "lodash";
import React from "react";
import { connect } from "react-redux";

import Toast from "../../components/Toast/Toast";
import { IRootState } from "../../store/reducers";
import { fetchBrokerProfile } from "../../store/reducers/authentication";
import { fetchDocumentTypes } from "../../store/reducers/secureUploadDocumentType";

import {
  toggleUploadModal,
  toggleUploadToast,
  uploadDocument,
} from "../../store/reducers/secureUpload";

import { RouteComponentProps } from "react-router";
import { Col, Container, Row } from "reactstrap";
import UploadDocumentModal from "../../components/UploadDocumentModal/UploadDocumentModal";
import * as S from "../../constants/StringConstants";
import { ISecureUploadFile } from "../../store/models/secureUploadFile.model";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import "./ClientBuilder.scss";
import Welcome from "./Welcome";

export const saveSymbol = Symbol("SAVE FORM");
export const stepSymbol = Symbol("STEP FORM");
export const stepIndexSymbol = Symbol("STEP INDEX");

/**
 * Client Builder Component Properties
 */
export interface IClientBuilderProps
  extends StateProps,
    DispatchProps,
    RouteComponentProps<{ id: string; client: string }> {
  brokerID: string;
  clientID: string;
  onBrokerChange: (notes: string) => void;
}

/**
 * Internal state of the Client Builder
 */
interface IClientBuilderState {
  // current page number
  page: number;
  isSubmitting: boolean;
  brokerID?: number;
}

export class ClientBuilder extends React.Component<IClientBuilderProps, IClientBuilderState> {
  constructor(props) {
    super(props);

    const page = get(props, "history.location.state.pageIndex", 0);

    if (page !== 0) {
      this.props.history.replace(undefined, {});
    }

    this.state = {
      page: page,
      isSubmitting: false,
      brokerID: undefined,
    };
  }

  async componentDidMount() {
    const { brokerID } = this.props;

    const id = parseInt(brokerID, 10);
    if (id) {
      this.setState((state) => ({
        ...state,
        brokerID: id,
      }));

      await this.props.fetchDocumentTypes();
      await this.props.fetchBrokerProfile(`${id}`);
    }
  }

  /**
   * Submit the current values and navigate to the next page.
   */
  submit = async (values) => {
    // const {  } = this.props;
    // const campaignId = get(this.props.match.params, "campaignId");
    // var caseDesign = values;
    // var newProposal = {
    //   ...currentProposal,
    //   caseDesign,
    //   campaignId
    // }
    //await this.props.submitProposal(newProposal);
  };

  uploadFiles = async (brokerID: number, acceptedFiles: File[]) => {
    try {
      for (const acceptedFile of acceptedFiles) {
        console.log("updating file ", brokerID, acceptedFile);
        try {
          const obj: ISecureUploadFile = {
            file: acceptedFile,
            note: "",
            documentType: 4, // other
          };
          await this.props.uploadDocument(brokerID, obj);
        } catch (e) {
          // TODO: notify/handle?
          alert(e);
        }
      }

      // if (this.fileTableRef) {
      //   this.fileTableRef.update({});
      // }
    } catch (e) {
      // TODO: notify/handle?
      alert(e);
    } finally {
      this.props.toggleUploadModal(false);
    }
  };

  render() {
    const { isUploadModalVisible, isUploadToastVisible } = this.props;

    const { page } = this.state;
    const { brokerID, clientID } = this.props;

    return (
      <div className="parentContainer">
        {clientID ? "" : <Header />}
        <div className="parentContainer__childfirst">
          {clientID ? "" : <Welcome />}

          <Toast
            message={S.SU_SUBMIT_SUCCESS_TOAST}
            onClose={() => {
              this.props.toggleUploadToast(false);
            }}
            open={isUploadToastVisible}
          />

          <Container>
            <UploadDocumentModal
              open={isUploadModalVisible}
              handleFiles={(files: any) => this.uploadFiles(this.state.brokerID, files)}
              onCancel={() => {
                this.props.toggleUploadModal(false);
              }}
            />

            <div className="upload-doc-container">
              <Row className="mb-5">
                <Col sm="12" className="text-center">
                  <h1 className="upload-files">{S.PDC_BROKER_QUOTE_TITLE}</h1>
                </Col>
              </Row>
              <Row>
                <Col sm="12" className="center bodyContainer">
                  <button
                    className="button-v2 button-v2__primary add-docs"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.toggleUploadModal(true);
                    }}>
                    {S.DOC_ADD_DOCUMENT_BUTTON}
                  </button>
                </Col>
              </Row>
            </div>

            <Row>
              <Col className="freespacefiller">&nbsp;</Col>
            </Row>
          </Container>
        </div>

        {clientID ? "" : <Footer />}
      </div>
    );
  }
}

const mapStateToProps = (state: IRootState) => {
  return {
    secureUpload: state.secureUpload,
    isUploadModalVisible: state.secureUpload.isUploadModalVisible,
    isUploadToastVisible: state.secureUpload.isUploadToastVisible,
  };
};

const mapDispatchToProps = {
  fetchBrokerProfile,
  toggleUploadModal,
  toggleUploadToast,
  uploadDocument,
  fetchDocumentTypes,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ClientBuilder);
